




































import Vue from 'vue';
import AppleStoreBadge from '~/components/global/Badges/AppleStoreBadge.vue';

export default Vue.extend({
  name: 'MainPageApp',
  components: {
    AppleStoreBadge,
  },
});
